<template lang='pug'>
    div 
        div(v-if="$route.params.lang == 'en'")
            h1.title Terms, Certificates & Standards
            
            section.section-block
                h2.section-title Terms and Conditions
                p.lead-text Here you can download the currently valid GTCs of BSS. The English text is only a nonbinding service. Only the German text is legally binding.
            
                .link-list
                    Downloadlink(
                        text='General Sales and Delivery Conditions (pdf, english)',
                        link="/pdf/General Sales and Delivery Conditions BSS.pdf"
                    )
                    Downloadlink(
                        text='Standard Terms and Conditions for Services and Project-Services (pdf, english)',
                        link="/pdf/Standard Terms and Conditions for Services and Project-Services BSS.pdf"
                    )
            
            section.section-block
                h2.section-title Principles and Guidelines
                p.lead-text Responsible conduct, the highest quality standards, and collaborative partnerships form the foundation of our corporate philosophy. Our Corporate Mission, Quality Policy, and Supplier Code of Conduct summarize these principles and are available for download as PDF documents:

                .link-list
                    Downloadlink(
                        text='Corporate Mission (pdf, english)',
                        link="/pdf/2025 Corporate Mission Statement BSS Hochspannungstechnik GmbH.pdf"
                    )
                    Downloadlink(
                        text='Quality Policy (pdf, english)',
                        link="/pdf/2025 Quality Policy BSS Hochspannungstechnik GmbH.pdf"
                    )
                    Downloadlink(
                        text='Supplier Code of Conduct (pdf, english)',
                        link="/pdf/2025-06-06 Supplier Code of Conduct BSS Hochspannungstechnik GmbH.pdf"
                    )

            section.section-block
                h2.section-title Certificates
                p.lead-text To ensure and continuously improve our quality standards, our processes and structures are certified according to the internationally recognized ISO 9001 standard. Our goal is not only to meet these requirements but to consistently exceed them – for lasting quality and maximum customer satisfaction.

                .link-list
                    Downloadlink(
                        text='ISO 9001:2015 Certificate (pdf, english)',
                        link="/pdf/Certificate_ISO_9001.pdf"
                    )
             
        div(v-if="$route.params.lang == 'de'")
            h1.title AGBs, Richtlinien & Zertifizierungen

            section.section-block
                h2.section-title Allgemeine Geschäftsbedingungen
                p.lead-text Hier finden Sie die aktuell gültigen AGBs der BSS zum Download. Verbindlich sind ausschließlich die deutschen Dokumente.

                .link-list
                    Downloadlink(
                        text='Allgemeine Verkaufs- und Lieferbedingungen (pdf, deutsch)',
                        link="/pdf/Allgemeine Verkaufs- und Lieferbedingungen BSS.pdf"
                    )
                    Downloadlink(
                        text='Allgemeine Geschäftsbedingungen für Dienst- und Werksleistungen (pdf, deutsch)',
                        link="/pdf/Allgemeine Geschäftsbedingungen für Dienst- und Werksleistungen BSS.pdf"
                    )

            section.section-block
                h2.section-title Grundsätze und Richtlinien
                p.lead-text Verantwortungsbewusstes Handeln, höchste Qualitätsansprüche und eine partnerschaftliche Zusammenarbeit bilden die Grundlage unserer Unternehmensphilosophie. Unser Unternehmensleitbild, die Qualitätspolitik sowie unser Lieferantenkodex fassen diese Grundsätze zusammen und stehen Ihnen nachfolgend als PDF-Dokumente zur Verfügung:

                .link-list
                    Downloadlink(
                        text='Unternehmensleitbild (pdf, deutsch)',
                        link="/pdf/2025 Unternehmensleitbild BSS Hochspannungstechnik GmbH.pdf"
                    )
                    Downloadlink(
                        text='Qualitätspolitik (pdf, deutsch)',
                        link="/pdf/2025 Qualitätspolitik BSS Hochspannungstechnik GmbH.pdf"
                    )
                    Downloadlink(
                        text='Lieferantenkodex (pdf, deutsch)',
                        link="/pdf/2025-06-06 Lieferantenkodex BSS Hochspannungstechnik GmbH.pdf"
                    )

            section.section-block
                h2.section-title Zertifizierungen
                p.lead-text Zur Sicherstellung und kontinuierlichen Verbesserung unserer Qualitätsstandards sind unsere Prozesse und Strukturen nach der international anerkannten Norm ISO 9001 zertifiziert. Unser Ziel ist es, diese Anforderungen nicht nur zu erfüllen, sondern dauerhaft zu übertreffen – für nachhaltige Qualität und maximale Kundenzufriedenheit.

                .link-list
                    Downloadlink(
                        text='ISO 9001:2015 Zertifikat (pdf, english)',
                        link="/pdf/Certificate_ISO_9001.pdf"
                    )
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | AGBs & Zertifikate",
            description:
                "Allgemeine Geschäftsbedingungen, Zertifikate und Standards der BSS Hochspannungstechnik GmbH",
        },
        en: {
            title: "BSS - Terms, Certificates and Standards",
            description:
                "Terms, Certificates and Standards of BSS Hochspannungstechnik GmbH",
        },
    },
};
</script>

<style lang='sass'>
.section-block
  margin-bottom: 40px

.section-title
  font-size: 1.4rem
  margin-bottom: 10px

.lead-text
  margin-bottom: 20px
  line-height: 1.5

.section-subtitle
  margin-top: 10px
  margin-bottom: 5px
  font-weight: 600

.link-list
  margin-bottom: 10px
</style>